<template>
    <div class="skintemperature">
        <div class="left">
            <div class="item">
                <p class="title"><i><img src="@/assets/Analysissoftware/ic_temperature@2x.png" alt=""></i>皮温波形图</p>
                <div class="chart">
                    <div ref="skinTemperatures" style="width: 100%;height:640px"></div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="Basicinfor">
                <label class="title">用户基本信息</label>
                <p class="item">部门：{{SkinTemperatureInfo.deptName}}</p>
                <p class="item">姓名：{{SkinTemperatureInfo.realName}}</p>
                <p class="item">性别：{{SkinTemperatureInfo.sex}}</p>
                <p class="item">年龄：{{SkinTemperatureInfo.age}}</p>
            </div>

            <div class="Bloodoxygenvalue">
                <p class="title"><i><img src="@/assets/Analysissoftware/ic_real_time@2x.png" alt=""></i>实时采集</p>
                <div class="average">
                    <i><img src="@/assets/Analysissoftware/ic_average@2x.png"></i>
                    <div>
                        <p>平均值</p>
                        <b>{{SkinTemperatureInfo.skinTemperatureAvg}}</b>
                    </div>
                </div>
                <div class="other">
                    <div class="item green">
                        <span>最大值</span>
                        <b>{{SkinTemperatureInfo.skinTemperatureMax}}</b>
                    </div>
                    <div class="item yellow">
                        <span>最小值</span>
                        <b>{{SkinTemperatureInfo.skinTemperatureMin}}</b>
                    </div>
                </div>
            </div>

        </div>

        <!-- 检测结果 -->
        <el-dialog
            :visible.sync="dialogVisible"
            width="800px"
            title="检测结果"
            :before-close="handleClose">
            <div class="Monitoringresults">
                <div class="item green">
                    <p>皮肤温度最大值为</p>
                    <b>36.5°C</b>
                </div>
                <div class="item blue">
                    <p>皮肤温度平均值为</p>
                    <b>36.4°C</b>
                </div>
                <div class="item orange">
                    <p>皮肤温度最小值为</p>
                    <b>36.3°C</b>
                </div>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    name:'electromechanical',
    data() {
        return {
            dialogVisible:false,
            SkinTemperatureInfo:{},
            userId:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
            time:null
        }
    },
    created(){
        this.getSkinTemperatureInfo()
    },
    mounted() {
        var _this=this;
        setTimeout(() => {
            _this.time=setInterval(() => {
                _this.getSkinTemperatureInfo();
            }, 1000);
        }, 2000);
    },
    methods: {
        getSkinTemperatureInfo(){
            this.$Http_Post('/bioassay/soft/getSkinTemperatureInfo',{userId:this.userId}).then(res=>{
                if(res.Code==0){
                    this.SkinTemperatureInfo=res.Data;
                    this.skinTemperatures(res.Data.skinTemperatures);
                }else{
                    this.$message.error(res.Message);
                }
                console.log(res)
            });
        },
        handleClose(){
            this.dialogVisible=false;
        },
        skinTemperatures(data){
            var Xdata=[];
            for(let item in data){
                Xdata.push(item);
            }
            var myChart = this.$echarts.init(this.$refs.skinTemperatures);
            var option = {
                tooltip: {},
                grid: {
                    top:30,
                    left: 30,  
                    right: 30,
                    bottom:30,
                },  
                xAxis: {
                    type: 'category',
                    data: Xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false,},  
                },
                series:[
                {
                    name:'温度',
                    data: data,
                    type: 'line',
                    smooth: true,
                    color: '#1FA1CC'  
            
                }
                ]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        }
    },
    destroyed(){
        clearInterval(this.time);
    }
}
</script>
<style>
.skintemperature img{width: 100%;display:block;}
.skintemperature{background:#291713;display: flex;min-height: 100%;padding: 15px;}
.skintemperature .left{flex: auto;margin-right: 10px;}
.skintemperature .left .item{background: #1F2626;padding: 10px;}
.skintemperature .left .item .title{background: #D6811A;color:#fff;font-size: 20px;display: flex;padding: 5px 10px;}
.skintemperature .left .item .title i{width:30px;display: inline-block;margin-right: 5px;}
.skintemperature .left .item .chart{background: #372C26;}
.skintemperature .right{width:240px;display: inline-block;}
.skintemperature .right .Basicinfor{background:url("../../../assets/Analysissoftware/bg_personal@2x.png") no-repeat;height:360px;background-size: 100% 100%;width: 240px;}
.skintemperature .right .Basicinfor .title{font-size: 22px;color: #fff;display: block;text-align: right;padding:5px 20px 20px 0;}
.skintemperature .right .Basicinfor .item{font-size: 18px;color: #43B8D9;padding: 15px 0 0 20px;}
.skintemperature .right .startBtn{width: 100%;margin: 10px 0;}
.skintemperature .right .Bloodoxygenvalue{background: rgba(255, 255, 255, 0.05);margin-top: 10px;}
.skintemperature .right .Bloodoxygenvalue .title{background: #D6811A;color:#fff;font-size: 20px;display: flex;padding: 5px 10px;}
.skintemperature .right .Bloodoxygenvalue .title i{width:30px;display: inline-block;margin-right: 5px;}
.skintemperature .right .Bloodoxygenvalue .average{background:url("../../../assets/Analysissoftware/bg_square@2x.png") no-repeat;background-size: 100% 100%;display: flex;align-items: center;justify-content: center;padding: 20px 0;margin: 30px 20px;}
.skintemperature .right .Bloodoxygenvalue .average i{width: 40px;margin-right: 10px;}
.skintemperature .right .Bloodoxygenvalue .average p{font-size: 20px;color: #239FC2;}
.skintemperature .right .Bloodoxygenvalue .average b{font-size: 44px;color: #239FC2;}
.skintemperature .right .Bloodoxygenvalue .other{display: flex;padding-bottom: 30px;margin: 0 10px;}
.skintemperature .right .Bloodoxygenvalue .other .item{background:url("../../../assets/Analysissoftware/bg_square@2x.png") no-repeat;background-size: 100% 100%;margin: 0 10px;    text-align: center;}
.skintemperature .right .Bloodoxygenvalue .other .item span{font-size: 16px;padding: 0 10px;float: left;}
.skintemperature .right .Bloodoxygenvalue .other .item b{font-size: 36px;text-align: center;}
.skintemperature .el-dialog__header{background: #D6811A;text-align: center;}
.skintemperature .el-dialog__title,.skintemperature .el-dialog__close{color: #fff;}
.skintemperature .Monitoringresults{margin:10px;display: flex;}
.skintemperature .Monitoringresults .item{background: #F2F2F2;text-align: center;margin: 0 1px;padding: 60px 0;width: -webkit-fill-available;}
.skintemperature .Monitoringresults .item p{font-size: 24px;padding-bottom: 25px;}
.skintemperature .Monitoringresults .item b{font-size: 48px;}
.green{color: #2BB361;}
.yellow{color: #E3C21B;}
.blue{color: #239FC2;}
.orange{color: #D6811A;}
</style>